import { TextPartHighlight } from '@components/Sections/Sections.styled';

import {
  MainTextStyled,
  TextUnbreakableNotMobile,
  TextBreakableMobile,
  TextPenUnderlineFirst,
  TextPenUnderlineFirstMobile,
  TextPenOutline,
  TextPenUnderlineSecondMobile,
  TextPenUnderlineSecond,
} from './MainText.styled';

export const MainText: React.FC = () => {
  return (
    <>
      {' '}
      <MainTextStyled>
        We hope our work will help everyone dissect the problem and get a better idea of where the issue stems from and{' '}
        <TextPartHighlight>
          <TextUnbreakableNotMobile>why&nbsp;it&nbsp;persists.</TextUnbreakableNotMobile>
          <TextBreakableMobile>why it persists.</TextBreakableMobile>
          <TextPenUnderlineFirst
            width="316"
            height="8"
            viewBox="0 0 316 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.00003 6.37402C43.4624 6.71678 86.5734 3.1486 128.921 5.13188C164.362 6.79166 198.108 1.67975 233.766 1.96758C261.378 2.19046 287.033 1.30861 314.382 1.52937"
              stroke="#D9FC51"
              strokeWidth="2"
              strokeLinecap="round"
              vectorEffect="non-scaling-stroke"
            />
          </TextPenUnderlineFirst>
        </TextPartHighlight>
      </MainTextStyled>
      <MainTextStyled>
        <TextPartHighlight>
          We&apos;re not pretending
          <TextPenUnderlineFirstMobile
            width="236"
            height="6"
            viewBox="0 0 236 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M235 5C203.288 5 171.114 2.87576 139.478 3.76613C113.001 4.51127 87.8305 1.59067 61.2004 1.59067C40.5783 1.59067 21.4249 1 0.999999 1"
              stroke="#D9FC51"
              strokeWidth="2"
              strokeLinecap="round"
              vectorEffect="non-scaling-stroke"
            />
          </TextPenUnderlineFirstMobile>
        </TextPartHighlight>{' '}
        to have all the answers. But by publishing this report, we hope to initiate a comprehensive dialogue and
        constructive discussion of the issues at hand, and thereby to make{' '}
        <TextPartHighlight>
          esports&nbsp;better
          <TextPenOutline
            isFullCentered
            width="243"
            height="46"
            viewBox="0 0 243 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M204.708 35.1879C246.546 42.7663 244.203 23.5252 239.56 16.068C226.721 -1.78258 158.259 1.18473 116.301 1.18473C51.8218 3.7329 -3.0939 3.2362 1.24027 23.8903C11.3364 56.8986 184.048 42.1645 206.739 38.9188C223.591 36.5084 234.165 31.829 235.367 30.1746"
              stroke="#D9FC51"
              strokeWidth="2"
              strokeLinecap="round"
              vectorEffect="non-scaling-stroke"
            />
          </TextPenOutline>
        </TextPartHighlight>{' '}
        as a whole.
      </MainTextStyled>
      <MainTextStyled>
        <TextPartHighlight>
          We thank
          <TextPenUnderlineSecondMobile
            width="109"
            height="6"
            viewBox="0 0 109 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 5C15.501 5 30.2126 2.87576 44.6791 3.76613C56.7858 4.51127 68.2954 1.59067 80.4725 1.59067C89.9022 1.59067 98.6604 1 108 1"
              stroke="#D9FC51"
              strokeWidth="2"
              strokeLinecap="round"
              vectorEffect="non-scaling-stroke"
            />
          </TextPenUnderlineSecondMobile>
        </TextPartHighlight>{' '}
        <TextPartHighlight>
          <TextUnbreakableNotMobile>every&nbsp;gamer&nbsp;and&nbsp;expert</TextUnbreakableNotMobile>
          <TextBreakableMobile>every gamer and expert</TextBreakableMobile>
          <TextPenUnderlineSecond
            width="388"
            height="7"
            viewBox="0 0 388 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M386.569 5.37402C334.324 5.79574 281.287 2.30769 229.18 4.36974C185.571 6.09545 144.06 1.04622 100.188 1.40036C66.2131 1.6746 34.6495 0.840441 0.999989 1.11206"
              stroke="#D9FC51"
              strokeWidth="2"
              strokeLinecap="round"
              vectorEffect="non-scaling-stroke"
            />
          </TextPenUnderlineSecond>
        </TextPartHighlight>{' '}
        who participated in our research, and everyone who supported us in making it possible. We also would like to
        thank Alesha Serada (University of Vaasa, Finland) and Dr Matilda Ståhl (Åbo Akademi University, Finland) for
        their contribution to the research and the project in general.
      </MainTextStyled>
    </>
  );
};
